import React from "react";
import "../App.css";
import BookingTable from "../components/Admin/Table";
import BookingManager from "../components/Admin/Time/index";
import { startOfToday } from "date-fns";
import { buildApiUrl } from "../config/api";

function TimeAdmin() {
  const today = startOfToday();
  const [activeUser, setActiveUser] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(today);
  const [requests, setRequests] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const loadRequests = () => {
      fetch(buildApiUrl("/api/requests"))
      .then((res) => res.json())
      .then((data) => {
        setRequests(data);
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
    };

    loadRequests();
    const intervalId = setInterval(loadRequests, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const selectedDateKey = formatDate(selectedDate);
  const filteredByTrainer = requests.filter(
    (item) => activeUser === null || item.trainer === activeUser.id
  );
  const selectedDayRequests = filteredByTrainer.filter(
    (item) => item.date === selectedDateKey
  );
  const successCount = selectedDayRequests.filter(
    (item) => item.status === "success"
  ).length;
  const failedCount = selectedDayRequests.filter(
    (item) => item.status === "failed"
  ).length;
  const pendingCount = selectedDayRequests.length - successCount - failedCount;

  return (
    <div className="App admin-page">
      {!isLoading ? (
        <div className="admin-shell">
          <div className="admin-links-bar">
            <a href="/time">Записи</a>
            <a href="/tournament-admin">Турнір</a>
            <a href="/tournament" target="_blank" rel="noreferrer">
              Публічна сторінка турніру
            </a>
          </div>
          <section className="admin-hero">
            <div>
              <div className="admin-kicker">Адмінпанель</div>
              <h1>Керування записами та вільними слотами</h1>
              <p>
                Оновлюйте доступний час, редагуйте текст для клієнтів та швидко
                обробляйте заявки на обрану дату.
              </p>
            </div>
            <div className="admin-stats-grid">
              <div className="admin-stat-card">
                <span>Заявок за день</span>
                <strong>{selectedDayRequests.length}</strong>
              </div>
              <div className="admin-stat-card">
                <span>Очікують</span>
                <strong>{pendingCount}</strong>
              </div>
              <div className="admin-stat-card success">
                <span>Підтверджено</span>
                <strong>{successCount}</strong>
              </div>
              <div className="admin-stat-card failed">
                <span>Відхилено</span>
                <strong>{failedCount}</strong>
              </div>
            </div>
          </section>

          <div className="admin-layout">
            <BookingManager
              activeUser={activeUser}
              setActiveUser={setActiveUser}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              requests={requests}
              setRequests={setRequests}
            />
            <BookingTable
              activeUser={activeUser}
              setActiveUser={setActiveUser}
              selectedDate={selectedDate}
              requests={requests}
              setRequests={setRequests}
            />
          </div>
        </div>
      ) : (
        <div className="admin-loading">ЗАВАНТАЖЕННЯ...</div>
      )}
    </div>
  );
}

export default TimeAdmin;
